var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFirstPlaceBadge = function SvgFirstPlaceBadge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFF1BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.5C21.7279 21.5 24.75 18.5899 24.75 15C24.75 11.4101 21.7279 8.5 18 8.5C14.2721 8.5 11.25 11.4101 11.25 15C11.25 18.5899 14.2721 21.5 18 21.5Z",
    stroke: "#FB7B04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5197 20.02L13.5098 27.4C13.5098 28.3 14.1398 28.74 14.9198 28.37L17.5998 27.1C17.8198 26.99 18.1898 26.99 18.4098 27.1L21.0998 28.37C21.8698 28.73 22.5098 28.3 22.5098 27.4V19.84",
    stroke: "#FB7B04",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5485 12.5V11.21H18.9585V18.5H17.5185V12.5H16.5485Z",
    fill: "#FB7B04"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFirstPlaceBadge);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9IiNGRkYxQkUiLz4KPHBhdGggZD0iTTE4IDIxLjVDMjEuNzI3OSAyMS41IDI0Ljc1IDE4LjU4OTkgMjQuNzUgMTVDMjQuNzUgMTEuNDEwMSAyMS43Mjc5IDguNSAxOCA4LjVDMTQuMjcyMSA4LjUgMTEuMjUgMTEuNDEwMSAxMS4yNSAxNUMxMS4yNSAxOC41ODk5IDE0LjI3MjEgMjEuNSAxOCAyMS41WiIgc3Ryb2tlPSIjRkI3QjA0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy41MTk3IDIwLjAyTDEzLjUwOTggMjcuNEMxMy41MDk4IDI4LjMgMTQuMTM5OCAyOC43NCAxNC45MTk4IDI4LjM3TDE3LjU5OTggMjcuMUMxNy44MTk4IDI2Ljk5IDE4LjE4OTggMjYuOTkgMTguNDA5OCAyNy4xTDIxLjA5OTggMjguMzdDMjEuODY5OCAyOC43MyAyMi41MDk4IDI4LjMgMjIuNTA5OCAyNy40VjE5Ljg0IiBzdHJva2U9IiNGQjdCMDQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjU0ODUgMTIuNVYxMS4yMUgxOC45NTg1VjE4LjVIMTcuNTE4NVYxMi41SDE2LjU0ODVaIiBmaWxsPSIjRkI3QjA0Ii8+Cjwvc3ZnPgo=";